import { Link } from 'react-router-dom';
import './Home.css';

const WA = 'https://wa.me/34614807628?text=Hola!%20Quiero%20reservar%20en%20NE%C3%96N%20Music%20Cocktail';

const IcoCocktail = () => (
  <svg viewBox="0 0 32 40" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
    <path d="M4 5L28 5L16 26L16 34"/><path d="M10 34L22 34"/>
    <path d="M24 12C22 8 18 8 16 10" strokeWidth="1.4"/>
  </svg>
);

const IcoMusic = () => (
  <svg viewBox="0 0 32 40" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
    <circle cx="7" cy="31" r="4"/>
    <circle cx="25" cy="25" r="4"/>
    <path d="M11 31L11 9L29 5L29 25"/>
    <line x1="11" y1="17" x2="29" y2="13"/>
  </svg>
);

const IcoStar = () => (
  <svg viewBox="0 0 32 40" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
    <path d="M16 5L19.5 13H28L21.5 18L24 26L16 21L8 26L10.5 18L4 13H12.5Z"/>
    <line x1="16" y1="26" x2="16" y2="34"/>
  </svg>
);

const IcoPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);

const IcoPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2A19.79 19.79 0 013.08 5.18 2 2 0 015.07 3h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L9.09 10.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);

const IcoWhatsApp = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const IcoMap = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
    <line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/>
  </svg>
);

const CATS = [
  'Cocktails', 'Cervezas', 'Vinos', 'Copas & Licores',
  'Refrescos & Zumos', 'Desayunos', 'Aperitivos',
  'Raciones', 'Hamburguesas', 'Asados',
];

export default function Home() {
  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent('weltascorp:open-cookies'));
  };

  return (
    <div>

      {/* ── Hero ─────────────────────────────────────────────────────────── */}
      <section className="nh-hero" aria-label="Portada">
        <div className="nh-hero-bg" role="presentation" />
        <div className="nh-hero-overlay" role="presentation" />
        <div className="nh-hero-content">
          <img
            src="/assets/neon/neon-logo-full-alpha.png"
            alt="NEON Music Cocktail"
            className="nh-logo"
            loading="eager"
            width="360"
            height="120"
          />
          <p className="nh-hero-claim">
            Cocktails · Música · Cocina<br />
            <span>para noches con luz propia</span>
          </p>
          <div className="nh-hero-ctas">
            <Link to="/carta" className="nh-btn nh-btn-primary">
              Ver carta
            </Link>
            <a href={WA} target="_blank" rel="noreferrer" className="nh-btn nh-btn-secondary">
              Reservar ahora
            </a>
          </div>
        </div>
      </section>

      <div className="nh-divider" />

      {/* ── Highlights ───────────────────────────────────────────────────── */}
      <section className="nh-section" aria-labelledby="nh-hl-heading">
        <div className="nh-section-head">
          <h2
            id="nh-hl-heading"
            className="nh-section-title"
            style={{ color:'var(--neon-cyan,#00f0ff)', textShadow:'0 0 14px rgba(0,240,255,.3)' }}
          >
            ¿Qué es NEON?
          </h2>
          <p className="nh-section-sub">Tres razones para venir esta noche</p>
        </div>
        <div className="nh-highlights">
          <article className="nh-hl-card nh-hl-card-cyan">
            <div className="nh-hl-ico" aria-hidden="true"><IcoCocktail /></div>
            <h3 className="nh-hl-title">Cocktails de firma</h3>
            <p className="nh-hl-text">
              18 cocktails exclusivos elaborados con productos premium. Desde el Neon Music hasta el Margarita Frozen — cada copa es una experiencia.
            </p>
          </article>
          <article className="nh-hl-card nh-hl-card-pink">
            <div className="nh-hl-ico" aria-hidden="true"><IcoMusic /></div>
            <h3 className="nh-hl-title">Música & ambiente</h3>
            <p className="nh-hl-text">
              Karaoke, sesiones en vivo y DJ nights. El lugar donde la música no para y el ambiente se enciende noche tras noche.
            </p>
          </article>
          <article className="nh-hl-card nh-hl-card-teal">
            <div className="nh-hl-ico" aria-hidden="true"><IcoStar /></div>
            <h3 className="nh-hl-title">Eventos & reservas</h3>
            <p className="nh-hl-text">
              Despedidas, cumpleaños, celebraciones especiales. Reserva tu espacio y disfruta de la mejor noche en Alcalá.
            </p>
          </article>
        </div>
      </section>

      <div className="nh-divider" />

      {/* ── Menu preview ─────────────────────────────────────────────────── */}
      <section className="nh-section" aria-labelledby="nh-carta-heading">
        <div className="nh-section-head">
          <h2
            id="nh-carta-heading"
            className="nh-section-title"
            style={{ color:'var(--neon-magenta,#ff2d95)', textShadow:'0 0 14px rgba(255,45,149,.3)' }}
          >
            Nuestra Carta
          </h2>
          <p className="nh-section-sub">
            Bebidas · Cocina · Asados · Hamburguesas y mucho más
          </p>
        </div>
        <div className="nh-menu-preview">
          <nav className="nh-cats-grid" aria-label="Categorías de la carta">
            {CATS.map(cat => (
              <Link key={cat} to="/carta" className="nh-cat-chip">{cat}</Link>
            ))}
          </nav>
          <Link to="/carta" className="nh-btn nh-btn-primary">
            Explorar carta completa
          </Link>
        </div>
      </section>

      <div className="nh-divider" />

      {/* ── Location ─────────────────────────────────────────────────────── */}
      <section className="nh-section" aria-labelledby="nh-loc-heading">
        <div className="nh-section-head">
          <h2
            id="nh-loc-heading"
            className="nh-section-title"
            style={{ color:'#00ffaa', textShadow:'0 0 14px rgba(0,255,160,.3)' }}
          >
            Encuéntranos
          </h2>
        </div>
        <div className="nh-loc-inner">
          <div>
            <ul className="nh-loc-list">
              <li className="nh-loc-item">
                <span className="nh-loc-ico" aria-hidden="true"><IcoPin /></span>
                <div>
                  <p className="nh-loc-label">Dirección</p>
                  <p className="nh-loc-value">C. de la Coruña, 16<br />28805 Alcalá de Henares, Madrid</p>
                </div>
              </li>
              <li className="nh-loc-item">
                <span className="nh-loc-ico" aria-hidden="true"><IcoPhone /></span>
                <div>
                  <p className="nh-loc-label">Teléfono</p>
                  <p className="nh-loc-value"><a href="tel:+34614807628">614 80 76 28</a></p>
                </div>
              </li>
              <li className="nh-loc-item">
                <span className="nh-loc-ico" aria-hidden="true" style={{ color:'#25D366' }}><IcoWhatsApp /></span>
                <div>
                  <p className="nh-loc-label">WhatsApp</p>
                  <p className="nh-loc-value">
                    <a href={WA} target="_blank" rel="noreferrer">Escríbenos directamente</a>
                  </p>
                </div>
              </li>
            </ul>
            <a
              href="https://maps.app.goo.gl/7dk9DCQMa6b3cbE5A"
              target="_blank"
              rel="noreferrer"
              className="nh-map-btn"
            >
              <IcoMap />
              Cómo llegar
            </a>
          </div>

          <div>
            <p className="nh-loc-label" style={{ marginBottom:'1.25rem' }}>Horario</p>
            <div className="nh-schedule-grid">
              <span className="nh-schedule-day">Horario</span>
              <span className="nh-schedule-time">09:00 — 02:00</span>
              <span className="nh-schedule-day">Fines de semana</span>
              <span className="nh-schedule-time">09:00 — 02:30</span>
              <span className="nh-schedule-day">Festivos</span>
              <span className="nh-schedule-time">09:00 — 02:30</span>
            </div>
            <p className="nh-section-sub" style={{ marginTop:'1.5rem', fontSize:'.77rem' }}>
              Horario sujeto a cambios en días festivos y eventos especiales.
            </p>
          </div>
        </div>
      </section>

      <div className="nh-divider" />

      {/* ── Footer CTA ───────────────────────────────────────────────────── */}
      <section className="nh-footer-cta nh-section" aria-label="Reservar mesa">
        <h2>¿Esta noche, NEON?</h2>
        <p>Reserva tu mesa y asegúrate un lugar<br />en la mejor noche de Alcalá de Henares.</p>
        <a href={WA} target="_blank" rel="noreferrer" className="neon-cta-reservar">
          Reservar por WhatsApp
        </a>
        <p className="nh-footer-copy">
          NEON MUSIC COCKTAIL &amp; PUB SL · NIF B24791212<br />
          C. de la Coruña, 16 · 28805 Alcalá de Henares · 614 80 76 28
        </p>
        <nav className="nh-footer-legal" aria-label="Enlaces legales">
          <Link to="/aviso-legal">Aviso legal</Link>
          <Link to="/privacidad">Privacidad</Link>
          <Link to="/politica-cookies">Cookies</Link>
          <Link to="/condiciones-reservas">Condiciones</Link>
          <button type="button" onClick={openCookieSettings}>Gestionar cookies</button>
        </nav>
      </section>

    </div>
  );
}
